







import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import PageTitle from '@/components/common/PageTitle.vue';

@Component({
  components: { AdminIframe, PageTitle },
})
export default class ProductAddIframe extends Vue {
  private title = '일반 상품 등록';

  private get remoteSrc() {
    const { query, path } = this.$route;
    let type = 'single';
    let action = 'add'; 
    
    if (path.includes('set')) {
      this.title = '세트 상품 등록';
      type = 'set';

      if (path.includes('edit')) {
        this.title = '세트 상품 수정';
        action = 'edit'
      }
    } else {
      if (path.includes('edit')) {
        this.title = '일반 상품 수정';
        action = 'edit';
      } else if (path.includes('copy')) {
        this.title = '일반 상품 복사'
        action = 'copy'
      } 
    }

    const queryString = new URLSearchParams({ serviceType: 'PREMIUM', ...query }).toString();

    return process.env.VUE_APP_ADMIN_REMOTE_URL + `/product/management/${type}/${action}?` + queryString;
  }
}
